import { render } from "./drop-down-menu.vue?vue&type=template&id=6b628c24&scoped=true"
import script from "./drop-down-menu.vue?vue&type=script&lang=js"
export * from "./drop-down-menu.vue?vue&type=script&lang=js"

import "./drop-down-menu.vue?vue&type=style&index=0&id=6b628c24&scoped=true&lang=css"
import "./drop-down-menu.vue?vue&type=style&index=1&id=6b628c24&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b628c24"]])

export default __exports__